import BusinessSizeType from '@/enums/business/BusinessSizeType';
import BusinessType from '@/enums/business/BusinessType';
import IBusiness from '../interfaces/IBusiness';

export default class Business implements IBusiness {
    public businessName: string | null = '';

    public businessSize: BusinessSizeType = BusinessSizeType.NotSet;

    public businessType: BusinessType = BusinessType.NotSet;

    public businessTimeEstablished: number = 0;

    public existingFleetSize: number = 0;

    public requiredFleetSize: number = 0;
}
